module.exports = __webpack_public_path__ + "img/product-bg-1.5cd45e96.png";